import { render, staticRenderFns } from "./help.vue?vue&type=template&id=764e8b4c&scoped=true&"
import script from "./help.vue?vue&type=script&lang=ts&"
export * from "./help.vue?vue&type=script&lang=ts&"
import style0 from "./help.vue?vue&type=style&index=0&id=764e8b4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764e8b4c",
  null
  
)

export default component.exports